import Column from "../Cloumn";
import React, { useEffect, useState } from "react";
import "@atlaskit/css-reset";
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import { fr } from "date-fns/locale";
import styled from "styled-components";
import WorkService from "../../../services/WorkService";
import {
  formattedDate,
  getTodayDate,
  transformToTasks,
} from "../../../../helpers";
import { Button, Form, Modal, Spinner } from "@themesberg/react-bootstrap";
import { DayPicker } from "react-day-picker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoneyBill, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
const TodayBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px;
`;
const Cards = styled.div`
  display: flex;
  justify-content: space-between;
`;
export default function () {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(0);
  const [idWork, setIdWork] = useState("");
  const [entryWorks, setEntryWorks] = useState([]);
  const [lateWorks, setLateWorks] = useState([]);

  const [today10Works, setToday10Works] = useState([]);
  const [today14Works, setToday14Works] = useState([]);
  const [todayRemainingWorks, setTodayRemainingWorks] = useState([]);

  const [tomorrowWorks, setTomorrowWorks] = useState([]);
  const [withoutForeseenWorks, setWithoutForeseenWorks] = useState([]);

  const [tasks, setTasks] = useState({});
  const [showDate, setShowDate] = useState(false);
  const [datePrevu, setDatePrevu] = useState("");
  const [data, setData] = useState({
    tasks: {},
    columns: {
      "column-1": {
        id: "column-1",
        title: "Travaux entrants",
        tasksIds: [],
      },
      "column-2": {
        id: "column-2",
        title: "Travaux retards",
        tasksIds: [],
      },
      "column-3": {
        id: "column-3",
        title: "Demain et +",
        tasksIds: [],
      },
      "column-4": {
        id: "column-4",
        title: "Pour 10h",
        tasksIds: [],
      },
      "column-5": {
        id: "column-5",
        title: "Pour 14h",
        tasksIds: [],
      },
      "column-6": {
        id: "column-6",
        title: "Après Midi",
        tasksIds: [],
      },
      "column-7": {
        id: "column-7",
        title: "Aucun date",
        tasksIds: [],
      },
      "column-8": {
        id: "column-8",
        title: "Prêt à sortir",
        tasksIds: [],
      },
    },
  });
  const [update, setUpdate] = useState(0);

  const getAllWorks = async () => {
    let ltasks = tasks;
    try {
      const res = await WorkService.organizeAllWorks();

      let data1 = transformToTasks(res.data.data.outgoing_dentist, ltasks);
      setEntryWorks(data1[0]);
      ltasks = data1[1];
      console.log("first ltasks===>", data1[0]);
      let data2 = transformToTasks(res.data.data.late, ltasks);
      setLateWorks(data2[0]);
      ltasks = data2[1];

      let data3 = transformToTasks(res.data.data.today.for_10.list, ltasks);
      setToday10Works(data3[0]);
      ltasks = data3[1];

      let data4 = transformToTasks(res.data.data.today.for_14.list, ltasks);
      setToday14Works(data4[0]);
      ltasks = data4[1];

      let data5 = transformToTasks(
        res.data.data.today.for_remaining.list,
        ltasks
      );
      setTodayRemainingWorks(data5[0]);
      ltasks = data5[1];

      let data6 = transformToTasks(res.data.data.tomorrow_plus, ltasks);
      setTomorrowWorks(data6[0]);
      ltasks = data6[1];

      let data7 = transformToTasks(
        res.data.data.without_foreseen_requested_date,
        ltasks
      );
      setWithoutForeseenWorks(data7[0]);
      ltasks = data7[1];
      setTasks(ltasks);
      setUpdate((prev) => prev + 1);
    } catch (err) {
      console.log(err);
    }
  };

  const receivedLaboratory = async (id) => {
    try {
      const response = await WorkService.recieveLaboratory(id);
      if (response.status === 200) {
        NotificationManager.success(
          "Travail bien reçu au laboratoire",
          "Notification"
        );
      }
    } catch (err) {
      NotificationManager.error("Une erreur s'est produite", "Notification");
    }
  };

  const updateForseen = async (workId, data) => {
    try {
      const response = await WorkService.editDatePrevu(workId, data);
      if (response.status === 200) {
        NotificationManager.success("Date prevu mis a jour", "Notification");
      }
    } catch (err) {
      NotificationManager.error("Une erreur s'est produite", "Notification");
    }
  };

  const sendLaboratory = async (id) => {
    try {
      const response = await WorkService.changeStatus(id, {
        step: "send_laboratory",
        courier_id: null,
      });
      if (response.status === 200) {
        NotificationManager.success("Travail Sortant", "Notification");
      }
    } catch (err) {
      NotificationManager.error("Une erreur s'est produite", "Notification");
    }
  };

  const editDatePrevuWork = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Create a new Date object from the timestamp string
    var date = new Date(datePrevu);

    // Extract components
    var formatedDate = formattedDate(date, active);

    //console.log(formattedDate);

    try {
      const response = await WorkService.editDatePrevu(idWork, {
        foreseen_delivery_date: formatedDate,
      });
      if (response.status === 200) {
        NotificationManager.success("Date prevu modifié avec succès");
        // console.log(response);
        setUpdate((prev) => prev + 1);
        setLoading(false);
        setShowDate(false);
      }
    } catch (err) {
      setLoading(false);
      // console.log(err);
    }
  };

  const onDragEnd = (result) => {
    let localData = data;
    const { destination, source, draggableId } = result;
    const workID = parseInt(draggableId.match(/\d+/)[0], 10);
    if (!destination) return;
    if (
      destination.droppableId === source.droppableId ||
      (destination.droppableId === source.droppableId &&
        destination.index === source.index) ||
      destination.droppableId === "column-1"
    ) {
      return;
    }

    // from entry to late

    console.log("test here ===>", destination.droppableId, source.droppableId);
    if (destination.droppableId === "column-8") {
      sendLaboratory(workID);
    }
    if (
      ["column-2", "column-3"].includes(destination.droppableId) &&
      source.droppableId === "column-1"
    ) {
      // changer status vers bien recue ( at_laboratory )
      receivedLaboratory(workID);
      setIdWork(workID);
      setShowDate(true);

      console.log("yes it's here");
      return;
    }
    if (source.droppableId === "column-1") {
      // changer status vers bien recue ( at_laboratory )
      receivedLaboratory(workID);
    }
    //console.log("destination droppableId", destination.droppableId);
    if (
      ["column-4", "column-5", "column-6"].includes(destination.droppableId)
    ) {
      let hour = "09:59:00";
      // change forseen date if () { 11 / 17 / }
      if (destination.droppableId === "column-5") {
        hour = "13:59:00";
      }
      if (destination.droppableId === "column-6") {
        hour = "16:59:00";
      }
      updateForseen(workID, { foreseen_delivery_date: getTodayDate(hour) });
    }

    let start = localData.columns[source.droppableId];
    let finish = localData.columns[destination.droppableId];
    if (start != finish) {
      let startTasksIds = Array.from(start.tasksIds);
      startTasksIds.splice(source.index, 1);
      let newStart = {
        ...start,
        tasksIds: startTasksIds,
      };

      let finishTasksIds = Array.from(finish.tasksIds);
      finishTasksIds.splice(destination.index, 0, draggableId);
      let newfinish = {
        ...finish,
        tasksIds: finishTasksIds,
      };

      const newData = {
        ...localData,
        columns: {
          ...localData.columns,
          [newStart.id]: newStart,
          [newfinish.id]: newfinish,
        },
      };

      setData(newData);
    } else {
      const column = localData.columns[source.droppableId];
      const newTaskIds = Array.from(column.tasksIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);
      const newColumn = {
        ...column,
        tasksIds: newTaskIds,
      };
      const newData = {
        ...localData,
        columns: {
          ...localData.columns,
          [newColumn.id]: newColumn,
        },
      };
      setData(newData);
    }
  };

  useEffect(() => {
    moment.locale("fr");

    getAllWorks();
  }, []);

  useEffect(() => {
    setData({
      tasks: tasks,
      columns: {
        "column-1": {
          id: "column-1",
          title: "Travaux entrants",
          tasksIds: entryWorks,
        },
        "column-2": {
          id: "column-2",
          title: "Travaux retards",
          tasksIds: lateWorks,
        },
        "column-3": {
          id: "column-3",
          title: "Demain et +",
          tasksIds: tomorrowWorks,
        },
        "column-4": {
          id: "column-4",
          title: "Pour 10h",
          tasksIds: today10Works,
        },
        "column-5": {
          id: "column-5",
          title: "Pour 14h",
          tasksIds: today14Works,
        },
        "column-6": {
          id: "column-6",
          title: "Après Midi",
          tasksIds: todayRemainingWorks,
        },
        "column-7": {
          id: "column-7",
          title: "Aucun date",
          tasksIds: withoutForeseenWorks,
        },
        "column-8": {
          id: "column-8",
          title: "Prêt à sortir",
          tasksIds: [],
        },
      },
    });

    console.log("data ===>", data);
  }, [
    entryWorks,
    lateWorks,
    tasks,
    today10Works,
    today14Works,
    todayRemainingWorks,
    tomorrowWorks,
    withoutForeseenWorks,
  ]);
  return (
    <Cards>
      <NotificationContainer />
      <DragDropContext onDragEnd={onDragEnd}>
        <Column
          key={data.columns["column-1"].id}
          column={data.columns["column-1"]}
          tasks={data.columns["column-1"].tasksIds.map(
            (taskId) => data.tasks[taskId]
          )}
        />
        <Column
          key={data.columns["column-2"].id}
          column={data.columns["column-2"]}
          tasks={data.columns["column-2"].tasksIds.map(
            (taskId) => data.tasks[taskId]
          )}
        />

        <TodayBlock className="d-flex flex-column">
          <h3>Aujourd'hui</h3>

          <Column
            key={data.columns["column-4"].id}
            column={data.columns["column-4"]}
            tasks={data.columns["column-4"].tasksIds.map(
              (taskId) => data.tasks[taskId]
            )}
          />
          <Column
            key={data.columns["column-5"].id}
            column={data.columns["column-5"]}
            tasks={data.columns["column-5"].tasksIds.map(
              (taskId) => data.tasks[taskId]
            )}
          />
          <Column
            key={data.columns["column-6"].id}
            column={data.columns["column-6"]}
            tasks={data.columns["column-6"].tasksIds.map(
              (taskId) => data.tasks[taskId]
            )}
          />
        </TodayBlock>

        <div className="d-flex flex-column">
          <div className="d-flex justify-content-end">
            <Column
              key={data.columns["column-8"].id}
              column={data.columns["column-8"]}
              tasks={data.columns["column-8"].tasksIds.map(
                (taskId) => data.tasks[taskId]
              )}
            />
          </div>
          <Column
            key={data.columns["column-3"].id}
            column={data.columns["column-3"]}
            tasks={data.columns["column-3"].tasksIds.map(
              (taskId) => data.tasks[taskId]
            )}
          />

          <Column
            key={data.columns["column-7"].id}
            column={data.columns["column-7"]}
            tasks={data.columns["column-7"].tasksIds.map(
              (taskId) => data.tasks[taskId]
            )}
          />
        </div>
      </DragDropContext>

      <Modal
        as={Modal.Dialog}
        centered
        show={showDate}
        onHide={() => setShowDate(false)}
        size={"lg"}
      >
        <Modal.Header>
          <Modal.Title className="h6">
            <FontAwesomeIcon icon={faMoneyBill} /> Changer la date prévue de
            sortie{" "}
          </Modal.Title>
          <Button
            variant="close"
            aria-label="Close"
            onClick={() => setShowDate(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={editDatePrevuWork}>
            <div className={"mb-2"}>
              <div className="d-flex  justify-content-center">
                <label className={"mb-2"}> Prévu pour le </label>
              </div>
              <div className="d-flex  justify-content-around">
                <DayPicker
                  mode="single"
                  selected={datePrevu}
                  onSelect={setDatePrevu}
                  locale={fr}
                  fromDate={new Date(moment().add(0, "days"))}
                />
                <div className="d-flex flex-column justify-content-center align-items-center">
                  <div
                    className={
                      active == 1
                        ? `btn btn-main mb-2 p-3`
                        : `btn btn-white mb-2 p-3`
                    }
                    onClick={() => setActive(1)}
                  >
                    <h3>11h</h3>
                  </div>
                  <div
                    className={
                      active == 2
                        ? `btn btn-main mb-2 p-3`
                        : `btn btn-white mb-2 p-3`
                    }
                    onClick={() => setActive(2)}
                  >
                    <h3>13h</h3>
                  </div>
                  <div
                    className={
                      active == 3
                        ? `btn btn-main mb-2 p-3`
                        : `btn btn-white mb-2 p-3`
                    }
                    onClick={() => setActive(3)}
                  >
                    <h3>17h</h3>
                  </div>
                </div>
              </div>
            </div>

            <div className={"d-flex justify-content-end mb-2"}>
              <Button type={"submit"} variant={"main"}>
                {loading ? (
                  <Spinner animation="border" />
                ) : (
                  <>
                    {" "}
                    <FontAwesomeIcon icon={faPlusCircle} /> Changer{" "}
                  </>
                )}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Cards>
  );
}
